import styled from 'styled-components';

export const TableContainer = styled.div`
  grid-area: History;
  margin-top: 15px;
`;

export const HeaderRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;
  align-self: flex-end;
  margin-bottom: 16px;

`;

export const WalletBalance = styled.span`
  font-size: 1.05rem;
  font-weight: 600;
  color: #2e7d32;
  border-radius: 6px;
  letter-spacing: 0.5px;
`;
